import { useTranslation } from "../../../../localization/useTranslation";
import ExternalAuditTable from "../../../../common/components/questionnaireComponents/externalAuditTable/ExternalAuditTable";
import useSystemAudits from "./SystemAudits.hooks";

export interface ISystemAuditsProps {
    systemId: string;
    systemName: string;
}

function SystemAudits(props: ISystemAuditsProps) {
    const { translateString } = useTranslation();
    const { externalAudits, isLoadingExternalAudits, refetchExternalAudits } = useSystemAudits({ systemId: props.systemId });

    return (
        <ExternalAuditTable
            data={externalAudits}
            isLoading={isLoadingExternalAudits}
            refetch={refetchExternalAudits}
            pageType="system"
            emptyStateText={translateString("noExternalAudits")}
            sessionStorageKey={`system-${props.systemId}-external-audits-filters`}
        />
    );
}

export default SystemAudits;
